export default __webpack_public_path__ + "static/media/green_plus.d2ed88ac.svg";